import { Component, Input } from '@angular/core';

import { SearchActivityEvents } from 'generated/graphql';

@Component({
  selector: 'app-create-user-event',
  templateUrl: './create-user-event.component.html'
})

export class ASCreateUserEventComponent {

  @Input() item: SearchActivityEvents.Node;
  /**
   *
   */
  constructor(
  ) {
  }

}
